<h2 mat-dialog-title>{{ "ERROR" | labelTranslate }}</h2>
<mat-dialog-content>
  <span class="subtitle">{{ "MESSAGE" | labelTranslate }}</span>
  @if (data.message) {
    @for (message of messageList; track message) {
      <p class="text-with-newline-code">
        {{ message | messageTranslate }}
      </p>
    }
  } @else {
    <p>{{ "NONE" | labelTranslate }}</p>
  }

  <span class="subtitle">{{ "TIMESTAMP" | labelTranslate }}</span>
  @if (data.timestamp) {
    <p>{{ data.timestamp | date: "mediumTime" }}</p>
  } @else {
    <p>{{ "NONE" | labelTranslate }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-stroked-button
    class="sub-button"
    cdkFocusInitial
    mat-dialog-close
  >
    {{ "CLOSE" | labelTranslate }}
  </button>
</mat-dialog-actions>
